export enum AuthResource {
  SignIn = 'Ingresar',
  SignInDescription = 'Ingrese sus credenciales para iniciar sesión',
  Email = 'Correo electrónico',
  InputEmail = 'Ingrese su correo electrónico',
  InputUser = 'Ingrese su usuario',
  Password = 'Contraseña',
  PasswordConfirm = 'Confirmar contraseña',
  Capcha =  'No soy robot',
  InputPassword =  'Ingrese su contraseña',
  SignInBtn = 'Iniciar sesión',
  SignInMessage = '¿Tienes cuenta?',
  SignInMessageAction = 'Ingresar',
  Register = '¿Aún no te encuentras registrado?.',
  RegisterClic = 'Click aqui',
  recoveryPasswordDescription = '¿Olvide mi contraseña?.',
  recoveryPassword = '¿Desea recuperarla?',
  InvalidCredentials = 'Credenciales invalidas. intentos restantes',
  UnlockedDescription = 'Credenciales invalidas. Este usuario ha sido bloqueado por seguridad.',
  Unlocked = 'Desbloquear',
  UnlockedTitle = 'Desbloqueo de usuario',
  UnlockedPageDescription = 'Información requerida',
  User = 'Usuario',
  Document = 'Número de documento',
  Mobile = 'Celular',
  Phone = 'Telefono',
  Birthdate = 'Fecha de nacimiento',
  UnlockedPagePassword = 'Debe tener minimo 8 caracteres.',
  UnlockedPagePassword2 = 'Debe tener minimo 1 letra mayuscula.',
  UnlockedPagePassword3 = 'Debe tener minimo 1 caracter numerico.',
  UnlockedPagePassword4 = 'Debe tener 1 carácter simbólico (#*%.).',
  RecoverPasswordBtn = 'Recuperar',
  RecoveryTitle = 'Cambiar contraseña',
  RecoveryPageDescription = 'Información requerida',
  RegisterTitle = 'Registrar cuenta',
  RegisterType = 'Tipo de persona',
  RegisterTypeDocument = 'Tipo de documento',
  RegisterDocument = 'Documento',
  RegisterDocumentArchive = 'Documentos Solicitados',
  RegisterBasic = 'Datos basicos',
  RegisterBasicJuridico = 'Datos Empresariales',
  RegisterNational = 'Datos de notificación nacional',
  RegisterAddress = 'Generar dirección',
  RegisterFactUnica = 'Autoriza uso de la Factura única Nacional',
  RegisterAutorization = 'Autorización de notificación y tratamiento de datos',
  RegisterDatosAcceso = 'Datos de Acceso',
  RegisterDatosDescription = 'La contraseña debe cumplir con las siguientes caracteristicas:',
  RegisterBasicFirstName = 'Primer nombre',
  RegisterBasicSecondName = 'Segundo nombre',
  RegisterBasicFirstLastName = 'Primer apellido',
  RegisterBasicSecondLastName = 'Segundo apellido',
  RegisterBasicRazonSocial = 'Razón Social',
  RegisterBasicTradeName = 'Nombre Comercial',
  LogoutTitle = ' ¡Espera un momento!',
  LogoutConfirm = '¿Seguro que deseas cerrar sesión?',
  LogoutSuccess = 'Se ha cerrado la session correctamente..',
  LogoutError = 'Ha ocurrido un error.',
  Logout = 'Salir',
  ExcepcionSignIn = '',
  EmailValid = '',
  EmailForbidden = '',
  EmailNotFound = '',
  ErrorSendCode = '',
  ConfirmSendEmailCode = '',
  Code = '',
  InputCode = '',
  Cancel = 'Cancelar',
  Acept = 'Aceptar',
  RegisterNatural = 'Registro Persona Natural',
  RegisterJuridico = 'Registro Persona Jurídica',
  RegisterBasicAddressComp = 'Complemento Dirección',
  RegisterBasicAddress = 'Dirección',
  RegisterBasicEmail = 'E-mail',
  RegisterBasicEmailConfirm = 'Confirmación de E-mail',
  RegisterBasicCelular = 'Celular',
  RegisterBasicCelularConfirm = 'Confirmación de Celular',
  RegisterBasicUserName = 'Nombre de Usuario',
  PaisNacimiento = 'Pais de nacimiento'
}
